import { render, staticRenderFns } from "./MDschedule.vue?vue&type=template&id=b58273a4"
import script from "./MDschedule.vue?vue&type=script&lang=js"
export * from "./MDschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports